export const isExist = function (val, key, array) {
  let valList = []
  array.forEach(item => {
    valList.push(item[key])
  })
  if (valList.indexOf(val) > -1) {
    return true
  } else {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/utils/is_exist.js